import { styles } from './template.scss';
import { styles as commonImStyles } from '../../common/common.scss';
import { styles as commonStyles } from '../../../../assets/common.scss';
import { styles as colorHelpersStyles } from '../../../../assets/color-helpers.scss';
import { styles as widgetSharedStyles } from '../../../../assets/widget-shared.scss';
import { styles as flexboxHelpersStyles } from '../../../../assets/flexbox-helpers.scss';
import { styles as styleHelpers } from '../../../../assets/style-helpers.scss';
import { styles as textHelpersStyles } from '../../../../assets/text-helpers.scss';

export const templateIntegrityMonitorRuleSetForm = document.createElement('template');

templateIntegrityMonitorRuleSetForm.innerHTML = `
  <style>${widgetSharedStyles}</style>
  <style>${colorHelpersStyles}</style>
  <style>${flexboxHelpersStyles}</style>
  <style>${styleHelpers}</style>
  <style>${textHelpersStyles}</style>
  <style>${commonStyles}</style>
  <style>${commonImStyles}</style>
  <style>${styles}</style>

  <div class="wrapper">

    <div class="loading-container">
      <gz-progress-spinner size="large"></gz-progress-spinner>
    </div>

    <div class="form-wrapper">
      <div class='form-section'>
        <gz-title class="title" fontweight="500" fontsize="18" id="form-title"></gz-title>

        <gz-form-field id="rule-set-name-form-field" class='label-mw-250' label='' required>
          <gz-input gz-form-input placeholder="" inputwidth="240"></gz-input>
          <gz-input-error></gz-input-error>
        </gz-form-field>

        <gz-form-field id='rule-set-description-form-field' label='' class='label-mw-250'>
          <gz-input gz-form-input placeholder="" inputwidth="240"></gz-input>
          <gz-input-error></gz-input-error>
        </gz-form-field>
      </div>
    </div>

    <div class="bottom-buttons">
      <gz-button id="saveButton" disabled></gz-button>
      <div class='flex-auto'></div>
      <gz-button id="cancelButton" type="outline" color="secondary"></gz-button>
    </div>
  </div>
`;
